module.exports = __webpack_public_path__ + "img/bcard_1.663bbd85.png";